import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [ "form", "watchedComplete", "modal" ]

  connect() {
    let self = this;

    if (typeof(Storage) === "undefined") {
      console.log("No web storage Support.");
    }
    self.localStorage = window.localStorage;

    // Read and load session back
    let sessionData = self.read();
    let jsonSession = JSON.parse(sessionData);
    if (jsonSession) {
      self.scormAPI.loadFromJSON(jsonSession);
    }

    // Scorm 1.2
    window.API.on("LMSSetValue.cmi.core.lesson_status", function(CMIElement, value) {
      if (CMIElement == "cmi.core.lesson_status" && value == "completed") {
        self.submitHandler();
      }
    });

    // Scorm 2004
    window.API_1484_11.on("SetValue.cmi.completion_status", function(CMIElement, value) {
      if (CMIElement == "cmi.completion_status" && value == "completed") {
        self.submitHandler();
      }
    });

    // Write session when unload
    $(document).on("turbolinks:unload.scorm_video_form", function() {
      var simplifiedObject = self.scormAPI.cmi.toJSON();
      self.write(JSON.stringify(simplifiedObject));
    });

    if (this.hasModalTarget) {
      $(this.modalTarget).on("hidden.bs.modal", function () {
        var simplifiedObject = self.scormAPI.cmi.toJSON();
        self.write(JSON.stringify(simplifiedObject));

        // Need to remove this dialog otherwise, audio still be playing.
        this.remove();
        self.scormAPI.reset();
      });
    }
  }

  disconnect() {
    this.scormAPI.reset();
    if (this.hasWatchedCompleteTarget) {
      this.$watchedCompleteTarget.val("false");
    }
    $(document).off("turbolinks:unload.scorm_video_form");
  }

  submitHandler() {
    // Mark watching video has completed
    if (this.hasWatchedCompleteTarget) {
      this.$watchedCompleteTarget.val("true");
    }

    // Submit the form
    window.setTimeout(() => {
      this.$formTarget.submit();
    }, 1000);
  }

  write(value) {
    this.localStorage.setItem(this.storageIdentifier, value);
  }

  read() {
    return this.localStorage.getItem(this.storageIdentifier);
  }

  get $watchedCompleteTarget() {
    return $(this.watchedCompleteTarget);
  };

  get $formTarget() {
    return $(this.formTarget);
  }

  get storageIdentifier() {
    return this.data.get("storageIdentifier") || this.$formTarget.data("scorm-video-form-storage-identifier");
  }

  get scormVersion() {
    return this.data.get("scormVersion") || this.$formTarget.data("scorm-video-form-scorm-version");
  }

  get scormAPI() {
    if (this.scormVersion == "1.2") {
      return window.API;
    } else {
      return window.API_1484_11;
    }
  }
}
